import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { selectCustomerPortalUrl } from 'src/app/root-store/selectors';
import { AppState } from 'src/app/root-store/state';

@Component({
    selector: 'app-jobseeker-recruitment-box',
    templateUrl: "./redesign/jobseeker-recruitment-box.component.html",
    styleUrls: ["./redesign/jobseeker-recruitment-box.component.scss"],
    standalone: false
})
export class JobseekerRecruitmentBoxComponent implements OnInit {
  
  customerPortalUrl$: Observable<string>;

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.customerPortalUrl$ = this.store.pipe(select(selectCustomerPortalUrl));
  }
}
